module.exports = __webpack_public_path__ + "img/check-icon-green.022d959e.svg";